import axios from "axios";
import Cookies from "js-cookie";
import {
  FETCH_PROVIDERS_PROFILES_FAILURE,
  FETCH_PROVIDERS_PROFILES_REQUEST,
  FETCH_PROVIDERS_PROFILES_SUCCESS,
  FETCH_USER_PROFILE_FAILURE,
  FETCH_USER_PROFILE_REQUEST,
  FETCH_USER_PROFILE_SUCCESS,
  UPDATE_PROFILE_IMAGE_FAILURE,
  UPDATE_PROFILE_IMAGE_REQUEST,
  UPDATE_PROFILE_IMAGE_SUCCESS,
  UPDATE_PROFILE_STATUS_FAILURE,
  UPDATE_PROFILE_STATUS_REQUEST,
  UPDATE_PROFILE_STATUS_SUCCESS,
} from "./actionType";

const ACCOUNTS_URL = process.env.REACT_APP_ACCOUNTS_URL;

export const fetchUserProfile =
  ({ userId, accessToken, tenantId,navigate }) =>
  async (dispatch) => {
    dispatch({ type: FETCH_USER_PROFILE_REQUEST });
    
    try {
      const response = await axios.get(
        `${ACCOUNTS_URL}/profiles/user-profile/${userId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
            usertype: "central_admin",
            tenantId,
          },
        }
      );
   
      Cookies.set("Token", response.data.data.access_token, { expires: 3 / 24 });
      Cookies.set("TenantId", tenantId, { expires: 3 / 24 });
      Cookies.set("UserId", userId, { expires: 3 / 24 });
    
      dispatch({
        type: FETCH_USER_PROFILE_SUCCESS,
        payload: response.data.data.profile,
      });
    } catch (error) {
      // navigate("/unauthorized")
      dispatch({
        type: FETCH_USER_PROFILE_FAILURE,
        payload: error.response?.data?.error?.message || "Error fetching user profile",
      });
    }
  };
 
  export const getAllProvicersprofiles=({page=null,limit=null,sortBy=null,order=null})=>async(dispatch)=>{
    dispatch({type:FETCH_PROVIDERS_PROFILES_REQUEST})
    try {
      const response  = await axios.get(`${ACCOUNTS_URL}/profiles/get-all-providers-profiles?page=${page}&limit=${limit}&sortBy=${sortBy}&order=${order}`,{
        headers:{
            constentType:"application/json",
            Authorization:`Bearer ${Cookies.get("Token")}`,
        }
      })
 
      dispatch({
        type:FETCH_PROVIDERS_PROFILES_SUCCESS,
        payload:response.data.data 
      })
    } catch (error) {
      dispatch({
        type:FETCH_PROVIDERS_PROFILES_FAILURE,
        payload:error?.response?.data?.error?.message || "Error fetching providers profiles"
      })
      
    }
  }


  export const updateProfileStatus=({id,status,tenantId})=>async (dispatch)=>{
     dispatch({type:UPDATE_PROFILE_STATUS_REQUEST})
    try {
      const response = await axios.patch(`${ACCOUNTS_URL}/profiles/update-profile-status/${id}/${tenantId}/provider`,{status},
      {
        headers:{
            constentType:"application/json",
            Authorization:`Bearer ${Cookies.get("Token")}`,
        }
      }
      )
      dispatch({
        type:UPDATE_PROFILE_STATUS_SUCCESS,
        payload:{profile:response.data.data,profileId:id} 
      })
 
    } catch (error) {
      dispatch({
        type:UPDATE_PROFILE_STATUS_FAILURE,
        payload:error?.response?.data?.error?.message || "Error fetching providers profiles"
      })
    }
  }


  export const editProfile = ({ body, id, userId }) => async (dispatch) => {
    dispatch({ type: UPDATE_PROFILE_IMAGE_REQUEST });
    try {
      const response = await axios.patch(
        `${ACCOUNTS_URL}/profiles/${id}/${userId}`,
        body,
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("Token")}`,
          },
        }
      );
  
      dispatch({ type: UPDATE_PROFILE_IMAGE_SUCCESS, payload: response.data.data });
      return response;
    } catch (error) {
      dispatch({
        type: UPDATE_PROFILE_IMAGE_FAILURE,
        payload: error?.response?.data?.error?.message || "Error fetching profiles",
      });
      throw new Error(error?.response?.data?.error?.message || "Error fetching profiles");
    }
  };
  
  


export const updateLastApp =
  ({ userId, body }) =>
  async () => {
    try {
      const response = await axios.patch(
        `${ACCOUNTS_URL}/lastapp/${userId}`,
        body
      );
      return response;
    } catch (error) {
      return error.response;
    }
  };
